import { Injectable, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarComponent } from "../ui/snack-bar/snack-bar.component";
import { LogoutSnackBarComponent } from '../ui/snack-bar/logout-snack-bar/logout-snack-bar.component';
import { InvalidFormularSnackBarComponent } from '../ui/snack-bar/invalid-formular-snack-bar/invalid-formular-snack-bar.component';
import { FormularInitFailedSnackBarComponent } from "../ui/snack-bar/formular-init-failed-snack-bar/formular-init-failed-snack-bar.component";
import { FormularSubmitFailedSnackBarComponent } from "../ui/snack-bar/formular-submit-failed-snack-bar/formular-submit-failed-snack-bar.component";
import { MultiFormularSnackBarComponent } from "../ui/snack-bar/multi-open-formular-snack-bar/multi-open-formular-snack-bar.component";

@Injectable({ providedIn: 'root' })
export class SnackBarService {
    private _snackBar = inject(MatSnackBar);
    private snackBarPanelDefaultClasses = ['snack-bar-panel-default'];

    openErrorSnackBar(): void {
        this._snackBar.openFromComponent(SnackBarComponent, { panelClass: [...this.snackBarPanelDefaultClasses, 'snack-bar-panel-error'] });
    }
    openSuccessSnackBar(): void {
        this._snackBar.openFromComponent(SnackBarComponent, { panelClass: [...this.snackBarPanelDefaultClasses, 'snack-bar-panel-success'], duration: 5000 });
    }
    openLogoutSnackBar(): void {
        this._snackBar.openFromComponent(LogoutSnackBarComponent, { panelClass: ['snack-bar-panel-unauthorized'] });
    }
    openInvalidFormularSnackBar(): void {
        this._snackBar.openFromComponent(InvalidFormularSnackBarComponent, { panelClass: ['snack-bar-panel-unauthorized'] });
    }
    openFormularInitFailedSnackBar(): void {
        this._snackBar.openFromComponent(FormularInitFailedSnackBarComponent, { panelClass: ['snack-bar-panel-unauthorized'] });
    }
    openFormularSubmitFailedSnackBar(): void {
        this._snackBar.openFromComponent(FormularSubmitFailedSnackBarComponent, { panelClass: ['snack-bar-panel-unauthorized'] });
    }
    openMultiFormularSnackBar(): void {
        this._snackBar.openFromComponent(MultiFormularSnackBarComponent, { panelClass: ['snack-bar-panel-unauthorized'] });
    }
    closeSnackBar(): void {
        this._snackBar.dismiss();
    }
}
